export enum FastSendTemplateTypeEnum {
  default = 1,
  custom = 0,
}
